enum GeometryTypes {
  'Point' = 'Point',
  'LineString' = 'LineString',
  'Polygon' = 'Polygon',
  'MultiPoint' = 'MultiPoint',
  'MultiLineString' = 'MultiLineString',
  'MultiPolygon' = 'MultiPolygon',
}

export default GeometryTypes
